<template>
    <div class="orderData">
        <Page :renderSearchList="renderList" :searchData="searchData" :tableData="tableData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @changePageSize="handleChangePageSize" @changeSearchDat="handleChangeSearchData" @search="handleSearch" showDownload downloadText="导出" @download="handleDownload">
            <div class="table-content" ref="tableContent">
                <div class="orderData-total" ref="tableTotal">
                    <div :style="`display: ${item.key === 'orderValidEstimateCosPrice' && userInfo.showOrderValidNum !== 1 ? 'none' : ''}`" class="orderData-item" v-for="(item, key) in orderTotalRenderList" :key="key">
                        <Popover v-if="item.popoverText" placement="top" width="300" trigger="hover" :content="item.popoverText">
                            <div slot="reference">
                                <img :src="item.img" alt="">
                                <div class="orderData-item-content">
                                    <div class="orderData-item-value">{{ orderData[item.key] | filterTotal }}</div>
                                    <div class="orderData-item-label">{{ item.name }}</div>
                                </div>
                            </div>
                        </Popover>

                        <div v-else>
                            <img :src="item.img" alt="">
                            <div class="orderData-item-content">
                                <div class="orderData-item-value">{{ orderData[item.key] | filterTotal }}</div>
                                <div class="orderData-item-label">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-box">
                    <Table :data="tableData" size="medium" stripe :height="tableHeight" v-if="tableData.length && !isLoading">
                        <el-table-column prop="synGoodsId" label="推广ID" width="130"></el-table-column>
                        <el-table-column prop="toPlatName" label="电商平台" min-width="40"></el-table-column>
                        <el-table-column prop="orderId" label="订单号" min-width="40"></el-table-column>
                        <el-table-column prop="orderGoodsId" label="商品ID" min-width="40"></el-table-column>
                        <el-table-column prop="skuId" label="skuid" min-width="40"></el-table-column>
                        <el-table-column prop="skuName" label="商品描述" min-width="90"></el-table-column>
                        <el-table-column prop="price" label="商品单价" width="90"></el-table-column>
                        <el-table-column prop="estimateCosPrice" label="实付金额" width="90">
                            <template slot-scope="scope">
                                <div>{{ scope.row.synValidOrder == '1' ? scope.row.estimateCosPrice : "0" }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="synOrderStatusDesc" label="当前状态" width="80"></el-table-column>
                        <el-table-column prop="fromPlatName" label="引流平台" width="80"></el-table-column>
                        <el-table-column prop="advertiseId" label="引流账号id" min-width="40"></el-table-column>
                        <el-table-column prop="planId" label="引流计划id" min-width="40"></el-table-column>

                        <!-- <el-table-column prop="fromPlat" label="引流平台账户ID" min-width="40"></el-table-column> -->
                        <el-table-column prop="orderTime" label="订单更新时间" width="152"></el-table-column>
                    </Table>
                </div>

                <div class="table-normal" v-if="!tableData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>

                <div v-if="isLoading">
                    <WfLoading></WfLoading>
                </div>
            </div>
        </Page>

        <div :class="`orderData-mobile`">
            <PageMobile title="订单数据" :renderSearchList="renderMobileList" :searchData="searchMobileData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @search="handleSearch" @change="handleChangeSearchMobileData" :showDownload="false" @download="handleDownload">
                <div class="orderData-total" ref="tableTotal">
                    <div :style="`display: ${item.key === 'orderValidEstimateCosPrice' && userInfo.showOrderValidNum !== 1 ? 'none' : ''}`" class="orderData-item" v-for="(item, key) in orderTotalRenderList" :key="key">
                        <div>
                            <img :src="item.img" alt="">
                            <div class="orderData-item-content">
                                <div class="orderData-item-value">{{ orderData[item.key] | filterTotal }}</div>
                                <div class="orderData-item-label">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-content" ref="tableContentMobile" :style="`height: ${tableHeight}px`">
                    <Table :data="tableData" size="small" :height="tableHeight" stripe v-if="tableData.length && !isLoading">
                        <el-table-column prop="synGoodsId" label="推广ID" width="130"></el-table-column>
                        <el-table-column prop="toPlatName" label="电商平台" width="90"></el-table-column>
                        <el-table-column prop="orderId" label="订单号" width="120"></el-table-column>
                        <el-table-column prop="orderGoodsId" label="商品ID" width="120"></el-table-column>
                        <el-table-column prop="skuId" label="skuid" width="120"></el-table-column>
                        <el-table-column prop="skuName" label="商品描述" width="240"></el-table-column>
                        <el-table-column prop="price" label="商品单价" width="90"></el-table-column>
                        <el-table-column prop="estimateCosPrice" label="实付金额" width="90">
                            <template slot-scope="scope">
                                <div>{{ scope.row.synValidOrder == '1' ? scope.row.estimateCosPrice : "0" }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="synOrderStatusDesc" label="当前状态" width="80"></el-table-column>
                        <el-table-column prop="fromPlatName" label="引流平台" width="80"></el-table-column>
                        <el-table-column prop="advertiseId" label="引流账号id" width="120"></el-table-column>
                        <el-table-column prop="planId" label="引流计划id" width="120"></el-table-column>
                        <!-- <el-table-column prop="fromPlat" label="引流平台账户ID" min-width="40"></el-table-column> -->
                        <el-table-column prop="orderTime" label="订单更新时间" width="152"></el-table-column>
                    </Table>

                    <div class="table-normal" v-if="!tableData.length && !isLoading">
                        <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                        <span>目前暂无数据</span>
                    </div>

                    <div v-if="isLoading">
                        <WfLoading></WfLoading>
                    </div>
                </div>
            </PageMobile>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import fileDownload from 'js-file-download'
import Page from '@/components/page/page.vue'
import PageMobile from '@/components/pageMobile/pageMobile.vue'
import Icon from 'iview/src/components/icon';
import { Table, TableColumn, Loading, Popover } from 'element-ui';
import WfLoading from '@/components/loading/loading.vue'
Vue.use(Table)
Vue.use(TableColumn)
import moment from 'moment'
import { dateFormat, isEmpty, deepClone } from '@/utils/common.js'
import { renderList, orderTotalRenderList, renderMobileList } from './config'
export default {
    components: {
        Page,
        Icon,
        Table,
        WfLoading,
        PageMobile,
        Popover
    },
    data() {
        return {
            renderList: renderList,
            renderMobileList: renderMobileList,
            orderTotalRenderList: [...orderTotalRenderList],
            tableData: [],
            userInfo: JSON.parse(localStorage.userInfo || '{}'),
            searchData: {
                startCreateDate: dateFormat(new Date(), 'YYYY-MM-DD'),
                endCreateDate: dateFormat(new Date(), 'YYYY-MM-DD')
            },
            searchMobileData: {
                dates: [dateFormat(new Date(), 'YYYY-MM-DD'), dateFormat(new Date(), 'YYYY-MM-DD')]
            },
            isLoading: true,
            total: 0,
            pageSize: 15,
            current: 1,
            tableContentHeight: 320,
            tableTotalHeight: 0,
            orderData: {}
        }
    },
    filters: {
        filtersCell(value) {
            if (value) {
                return value
            } else {
                return '-'
            }
        },
        filterTotal(value) {
            if (isEmpty(value)) {
                return '--'
            } else {
                if (value >= 10000) {
                    return `${Math.round((Number(value) / 100)) / 100}W`
                } else {
                    return `${value || 0}`
                }
            }
        }
    },
    computed: {
        tableHeight() {
            if (this.tableContentHeight - this.tableTotalHeight - 25 < 360) {
                return 360
            }
            return this.tableContentHeight - this.tableTotalHeight - 25
        }
    },
    mounted() {
        if (window.innerWidth > 768) {
            this.tableContentHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight - 124 : ""
        } else {
            this.tableContentHeight = this.$refs.tableContentMobile ? this.$refs.tableContentMobile.offsetHeight : ""
        }
        //this.tableContentHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight : 0
        this.getOrderTotal()
        this.getTableData()
        this.initPage()
    },
    methods: {
        // 初始化页面
        initPage() {
            if (this.userInfo.showOrderValidNum !== 1) {
                this.orderTotalRenderList.splice(3, 1)
            }
        },
        // 获取订单数据
        getTableData() {
            this.isLoading = true
            this.$axios({
                url: '/api/syn/rebateDataPlat/order/list',
                data: {
                    ...this.searchData,
                    current: this.current,
                    pageSize: this.pageSize
                },
                method: 'GET'
            }).then((res) => {
                this.tableData = res.Data.data || []
                this.total = res.Data.total
                this.$nextTick(() => {
                    this.isLoading = false
                })
            })
        },

        // 获取订单汇总数据
        getOrderTotal() {
            this.$axios({
                url: '/api/syn/rebateDataPlat/order/total',
                data: {
                    ...this.searchData
                },
                method: 'GET'
            }).then((res) => {
                this.orderData = res.Data
                this.$nextTick(() => {
                    this.tableTotalHeight = this.$refs.tableTotal ? this.$refs.tableTotal.offsetHeight : 0
                })
            })
        },

        // 处理点击下载事件
        handleDownload() {
            let loadingInstance = Loading.service({
                fullscreen: true,
                lock: true,
                text: '正在导出...',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.$axios({
                url: '/api/syn/rebateDataPlat/order/listExport',
                data: {
                    ...this.searchData,
                    current: this.current,
                    pageSize: this.pageSize
                },
                method: 'GET',
                responseType: 'blob'
            }).then((res) => {
                loadingInstance.close()
                const { data } = res, fileName = decodeURI((res).headers['content-disposition']).substring(20)
                fileDownload(data, fileName)
            }).catch(() => {
                loadingInstance.close()
            })
        },

        // 处理搜索事件
        handleSearch() {
            this.current = 1
            this.getOrderTotal()
            this.getTableData()
        },

        // 处理移动端搜索改变事件
        handleChangeSearchMobileData(data) {
            const currData = { ...data }
            const dates = currData.dates
            delete currData.dates
            this.searchData = {
                startCreateDate: dates[0],
                endCreateDate: dates[1],
                ...currData
            }
        },

        // 当前页改变时触发
        handleChangeCurrrent(current) {
            this.current = current
            this.getTableData()
        },

        // pageSize改变时触发
        handleChangePageSize(pageSize) {
            this.current = 1
            this.pageSize = pageSize
            this.getTableData()
        },

        // 处理搜索框改变时触发
        handleChangeSearchData(eventData) {
            const { data, item } = eventData, key = item.key
            if (key === "startCreateDate") {
                const renderItem = { ...this.renderList[1] }
                if (data[key]) {
                    renderItem.minDate = moment(data[key]).format('YYYY-MM-DD')
                    renderItem.maxDate = moment(data[key]).add(31, 'd').format('YYYY-MM-DD')
                    if (data.endCreateDate) {
                        const dateTime = new Date(data[key]).getTime(), endTime = new Date(data.endCreateDate).getTime()
                        if (dateTime > endTime || dateTime < endTime - 86400000 * 31) {
                            data.endCreateDate = null
                        }
                    }
                } else {
                    renderItem.minDate = ""
                    renderItem.maxDate = ""
                }
                this.$set(this.renderList, 1, renderItem)
            }
            if (key === "endCreateDate") {
                const renderItem = { ...this.renderList[0] }
                if (data[key]) {
                    renderItem.minDate = moment(data[key]).subtract(31, 'd').format('YYYY-MM-DD')
                    renderItem.maxDate = moment(data[key]).format('YYYY-MM-DD')
                    if (data.startCreateDate) {
                        const dateTime = new Date(data[key]).getTime(), startTime = new Date(data.startCreateDate).getTime()
                        if (dateTime < startTime || dateTime > startTime + 86400000 * 31) {
                            data.startCreateDate = null
                        }
                    }
                } else {
                    renderItem.minDate = ""
                    renderItem.maxDate = ""
                }
                this.$set(this.renderList, 0, renderItem)
            }
            this.searchData = data
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .orderData {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background-color: #fff;
        .orderData-mobile {
            display: none;
        }
        .orderData-total {
            display: flex;
            flex-direction: row;
            //justify-content: space-between;
            margin-bottom: 20px;
            .orderData-item {
                position: relative;
                margin-right: 20px;
                flex: 1;
                max-width: 20%;
                img {
                    width: 100%;
                }
                .orderData-item-content {
                    position: absolute;
                    left: 60px;
                    top: 0;
                    bottom: 0;
                    margin: auto 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 54px;
                    .orderData-item-value {
                        height: 24px;
                        font-size: 32px;
                        line-height: 24px;
                        color: #fff;
                    }
                    .orderData-item-label {
                        height: 16px;
                        font-size: 16px;
                        color: #fff;
                    }
                }
            }
            .orderData-item:last-child {
                margin-right: 0;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .orderData {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1.1rem 0 0;
        background-color: #f7f7f7;
        .wf-page {
            display: none;
        }
        .orderData-content {
            flex: 1;
        }
        .orderData-mobile {
            min-height: 100%;
            display: block;
            display: flex;
            flex-direction: column;
            padding: 0 0.3rem 0.3rem;
            overflow-y: auto;
            .table-content {
                margin-top: 0.4rem;
                overflow-x: auto;
            }
            .orderData-total {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .orderData-item {
                    width: 3.08rem;
                    position: relative;
                    margin-bottom: 0.2rem;
                    img {
                        display: block;
                        width: 100%;
                    }
                    .orderData-item-content {
                        position: absolute;
                        left: 0.59rem;
                        top: -0.2rem;
                        bottom: 0;
                        height: 0.58rem;
                        margin: auto 0;
                        z-index: 2;
                        .orderData-item-value {
                            font-size: 0.36rem;
                            line-height: 0.27rem;
                            color: #fff;
                        }
                        .orderData-item-label {
                            margin-top: 0.12rem;
                            font-size: 0.24rem;
                            line-height: 0.2rem;
                            color: #fff;
                        }
                    }
                }
                .orderData-item:nth-child(2n + 1) {
                    margin-right: 0.2rem;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/dataEffect/orderData/index.vue